export interface IIterator<T> {

  first(): T;
  last(): T;
  previous(): T;
  next(): T;
  count(): number;

  isFirst(): boolean;
  isLast(): boolean;

  currentIndex: number;
  currentItem: T;
}

export class Iterator<T> implements IIterator<T> {

  // data members

  private _items: Array<T>;
  get items() {
    return this._items;
  }

  private _currentIndex = 0;
  get currentIndex() {
    return this._currentIndex;
  }
  set currentIndex(currentIndex) {

    if (!this.checkConsistency())
      return;

    if (currentIndex < 0 || currentIndex > this.items.length - 1)
      return;

    this._currentIndex = currentIndex;
    this._currentItem = this.items[currentIndex];
  }

  private _currentItem: T;
  get currentItem() {
    return this._currentItem;
  }
  set currentItem(currentItem) {

    if (!this.checkConsistency())
      return;

    let index = this.items.indexOf(currentItem);
    this.currentIndex = index;
  }

  // constructor

  constructor(items: Array<T>) {

    this._items = items;
  }

  // public functions

  first(): T {

    if (!this.checkConsistency())
      return null;

    this._currentIndex = 0;
    this._currentItem = this._items[this._currentIndex];

    return this._currentItem;
  }

  last(): T {

    if (!this.checkConsistency())
      return null;

    this._currentIndex = this._items.length - 1;
    this._currentItem = this._items[this._currentIndex];

    return this._currentItem;
  }

  next(): T {

    if (!this.checkConsistency())
      return null;

    if (this.currentIndex < this.items.length - 1)
      this._currentIndex++;

    this._currentItem = this.items[this.currentIndex];
    return this.currentItem;
  }

  previous(): T {

    if (!this.checkConsistency())
      return null;

    if (this.currentIndex > 0)
      this._currentIndex--;

    this._currentItem = this._items[this.currentIndex];
    return this.currentItem;
  }

  add(item: T) {
      this.items.push(item);
  }

  remove(item: T) {

    let index = this.items.indexOf(item);
    if (index < 0 || index > this.items.length - 1)
      return;

    this.removeByIndex(index);
  }

  removeByIndex(index: number) {

    if (index < 0 || index > this.items.length - 1)
      return;

    this.items.splice(index, 1);

    if (this.currentIndex > this.items.length - 1)
      this.currentIndex = this.currentIndex - 1;

    if (this.items.length === 0) {
      this._currentItem = null;
      this._currentIndex = 0;
    }
  }

  clear() {

    while (this.count() > 0)
      this.removeByIndex(0);
  }

  count(): number {

    if (this.items == null)
      return 0;

    return this.items.length;
  }

  isFirst() {
    return this.currentIndex == 0;
  }

  isLast() {
    return this.currentIndex == this.items.length - 1;
  }

  contains(item: T) {
    return this.items.indexOf(item) != -1;
  }

  // private functions

  private checkConsistency() {

    return this.items != null && this.items.length > 0;
  }
}
